import { Stack, Typography } from "@mui/material";
import Template from "../../../components/Dashboard/Template";
import CompanyBarChart from "./BarChart";
import { t } from "i18next";

const TopBusiness = ({ monthlyEarning, isLoading }) => {
  return (
    <Template
      primaryHeading={t("monthlyEarning")}
      secondaryHeading={t("graph")}
    >
      {monthlyEarning?.length == 0 && isLoading?.states === false ? (
        <Stack height={"100%"} alignItems={"center"} justifyContent={"center"}>
          <Typography variant="h5" fontWeight={600}>
            {t("noDataFound")}!
          </Typography>
        </Stack>
      ) : (
        <CompanyBarChart chartData={monthlyEarning} />
      )}
    </Template>
  );
};

export default TopBusiness;
